@if (state.initialized && state.adminUser) {
  <exam-detail-view-wrapper [backgroundColor]="'bg-white'" @appearDisappear>
    <ng-container title>
      <div class="flex items-center justify-between pl-2 pr-1">
        <span> {{ state.adminUser.first_name }} {{ state.adminUser.last_name }} </span>
      </div>
    </ng-container>

    <!-- @if (state.isUserAdmin) {
      <span class="m-2 text-sm text-gray-500">Admin's user permissions is not editable</span>
    } -->

    <!-- Material Tabs -->
    <mat-tab-group
      class="custom-mat-tab size-m tabs-body-expanded"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      animationDuration="250ms"
      [dynamicHeight]="false"
    >
      <!-- Permissions Tab -->
      <mat-tab label="Permissions">
        <ng-template matTabContent>
          <exam-review-permissions-list-view
            [searchCtrl]="searchCtrl"
            [isUserAdmin]="state.isUserAdmin"
            [isFormPristine]="reviewPermissionsForm.pristine"
            [isSaving]="isSaving()"
            (saveClicked)="save()"
          />
        </ng-template>
      </mat-tab>

      <!-- Payouts Tab -->
      <mat-tab label="Payouts">
        <ng-template matTabContent>
          <div class="h-full overflow-hidden">
            @if (state.adminUser.id) {
              <exam-payment-requests [config]="paymentRequestsConfig()" />
            } @else {
              <div class="flex h-full items-center justify-center">
                <span class="text-gray-500">Loading user data...</span>
              </div>
            }
          </div>
        </ng-template>
      </mat-tab>

      <!-- Analytics Tab -->
      <mat-tab label="Analytics">
        <ng-template matTabContent>
          <div class="flex h-full items-center justify-center">
            <span class="text-gray-500">Analytics content coming soon...</span>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <ng-container sidebar>
      <div class="space-y-4">
        <div class="flex items-center justify-between">
          <label class="text-md mb-1 block font-semibold text-gray-600"> User Settings</label>
          @if (!state.isCurrentUserSelected) {
            <dojo-icon-button [matMenuTriggerFor]="menu" [icon]="'ellipsis'" />
          }
        </div>

        <div>
          <label class="mb-1 block text-sm font-semibold"> First Name </label>
          <p class="text-sm">
            {{ state.adminUser.first_name || '—' }}
          </p>
        </div>

        <div>
          <label class="mb-1 block text-sm font-semibold"> Last Name </label>
          <p class="text-sm">
            {{ state.adminUser.last_name || '—' }}
          </p>
        </div>

        <div>
          <label class="mb-1 block text-sm font-semibold"> Email </label>
          <p class="text-sm">
            {{ state.adminUser.email }}
          </p>
        </div>

        <div>
          <label class="mb-1 block text-sm font-semibold"> Joined Date </label>
          <p class="text-sm">
            {{ state.adminUser.joined_date | date: 'medium' }}
          </p>
        </div>

        <hr />

        <div>
          <label class="mb-1 block text-sm font-semibold"> Role </label>
          @if (state.isCurrentUserSelected) {
            <span class="text-sm">{{ state.adminUser.role }}</span>
          } @else {
            <dojo-single-select
              [formCtrl]="roleControl"
              [optionLabel]="'label'"
              [optionValue]="'value'"
              [options]="roleOptions"
              [size]="'s'"
            >
              <ng-template [dojoSelectOption]="selectOptionType" let-option>
                <exam-cms-role-badge [role]="option.value" [config]="{ size: 'sm', showIcon: false }" />
              </ng-template>
            </dojo-single-select>
          }

          <div class="mt-4">
            <label class="mb-1 block text-sm font-semibold"> Payout Rate </label>
            <div class="flex items-center justify-between">
              <p class="text-sm text-gray-900 dark:text-white">
                @if (state.payoutRate) {
                  €{{ state.payoutRate | number: '1.2-2' }}/hour
                } @else {
                  <span class="text-gray-500 dark:text-gray-400">Not set</span>
                }
              </p>
              <div class="flex items-center gap-2">
                @if (state.payoutRate) {
                  <dojo-button [size]="'xs'" [fill]="'outline'" (click)="viewRateHistory()">
                    <dojo-icon icon="clock-rotate-left" />
                  </dojo-button>
                }
                <dojo-button [size]="'xs'" [fill]="'outline'" (click)="openEditRateDialog()">
                  <dojo-icon icon="edit" />
                </dojo-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </exam-detail-view-wrapper>
}

<mat-menu #menu="matMenu" xPosition="before">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="removeAccess()">
      <dojo-icon icon="times" class="mr-2 text-red-500" />
      <span class="text-red-500">Remove Access</span>
    </button>
  </ng-template>
</mat-menu>
